import React from "react";
const SERVICE_OPTIONS = [
  { key: "bp", label: "Fuel" },
  { key: "gulf", label: "Gulf Fuel" },
  { key: "tubbeesDessert", label: "Tubbees" },
  { key: "tubbeesSlushee", label: "Tubbees Slushee" },
  { key: "hoagies", label: "Hoagies" },
  { key: "subway", label: "Subway" },
  { key: "hermes", label: "Parcels / Evri" },
  { key: "wish", label: "Wish Parcels" },
  { key: "post", label: "Post Box" },
  { key: "Kegs", label: "Kegs" },
  { key: "ChilledKegs", label: "Chilled Kegs" },
  { key: "PerfectDraftRewards", label: "PerfectDraft Rewards" },
  { key: "atm", label: "ATM" },
  { key: "parking", label: "Parking" },
  { key: "toilets", label: "Toilets" },
  { key: "babyChange", label: "Baby Changing" },
  { key: "jetWash", label: "Jet Wash" },
  { key: "laundry", label: "Laundry" },
  { key: "speedQueen", label: "Speed Queen" },
  { key: "lottery", label: "National Lottery" },
  { key: "paypoint", label: "PayPoint" },
  { key: "premier", label: "Premier" },
  { key: "co_op", label: "Co-op" },
];

export default function StoreFilter({
  value,
  onChange,
  filteredCount,
  totalCount,
}) {
  return (
    <div className="store-filter">
      <label htmlFor="store-service-filter" className="store-filter-label">
        Filter by service
      </label>

      <select
        id="store-service-filter"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="store-filter-select"
      >
        <option value="all">All services</option>

        {SERVICE_OPTIONS.map((service) => (
          <option key={service.key} value={service.key}>
            {service.label}
          </option>
        ))}
      </select>

      <div className="store-filter-result">
        Showing {filteredCount} of {totalCount} stores
      </div>
    </div>
  );
}
